import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { SessionTimeOutModel } from '../../../../Data/Models/Common/session-time-out-model';
import { GlobalLogoutService } from '../../../../services/common/global-logout.service';

@Injectable({
  providedIn: 'root'
})
export class LoginapiService {







  Is_Stop_Interval: boolean = true;
  private sessionTimeOut: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  sessionTimeOut$ = this.sessionTimeOut.asObservable();

  baseUrl: any = this.configService.getAPIBaseUrl();
  constructor(private http: HttpClient, private configService: ConfigurationService, private globalLogoutService: GlobalLogoutService, private oAuthService: OAuthService,) { }

  SaveCharityDetails(charityDetails: any): Observable<string> {
    const url = `${this.baseUrl}/SaveCharityDetails`;
    return this.http.post<string>(url, charityDetails);
  }

  GetCharityGrid(CentralUserId: any): Observable<any> {
    const url = this.baseUrl + '/CharityDetails/GetCharityCount?CentralUserId=';
    return this.http.get(url + CentralUserId);
  }

  GetUserSession(UserId: any): Observable<any> {
    var url = `${this.baseUrl}/SessionTimeOut/RetrieveUserSession?UserId=${UserId}`
    return this.http.get(url);
  }

  UpdateSession(sessionTimeOut: SessionTimeOutModel): Observable<SessionTimeOutModel[]> {
    var url = `${this.baseUrl}/SessionTimeOut/UpdateUserSession`
    return this.http.post<SessionTimeOutModel[]>(url, sessionTimeOut);
  }
  setSession(data: boolean) {
    this.sessionTimeOut.next(data)
  }


  logOut(from?: any) {
    sessionStorage.clear();
    localStorage.clear();
    if (from != 'session') {
      this.globalLogoutService.publishLogout();
      this.oAuthService.revokeTokenAndLogout();
    }
    sessionStorage.setItem('ProductLogedOut', 'Yes')
    this.oAuthService.logOut();
  }

}
